import { HarvestProofReminderState } from '../components/harvest-proof-reminders-status/harvest-proof-reminders-status';

export const HARVEST_PROOF_REMINDER_MONTHS = [9, 9, 10] as const;
export const HARVEST_PROOF_REMINDER_DAYS = [1, 16, 6] as const;

export type HarvestProofReminderStepKey = 'september' | 'october' | 'november';

export interface HarvestProofReminderStep {
  key: HarvestProofReminderStepKey;
  sent: boolean;
  sentAt?: string | null;
  labelKey: `harvest-proof.reminders.${HarvestProofReminderStepKey}`;
}

export function getHarvestProofReminderSteps(
  form: HarvestProofReminderState,
): HarvestProofReminderStep[] {
  return [
    {
      key: 'september',
      sent: form.reminder1_sent,
      sentAt: form.reminder1_sent_at,
      labelKey: 'harvest-proof.reminders.september',
    },
    {
      key: 'october',
      sent: form.reminder2_sent,
      sentAt: form.reminder2_sent_at,
      labelKey: 'harvest-proof.reminders.october',
    },
    {
      key: 'november',
      sent: form.reminder3_sent,
      sentAt: form.reminder3_sent_at,
      labelKey: 'harvest-proof.reminders.november',
    },
  ];
}
